import type { PublicRegistration } from '../types';

/** Why the receipt tab is disabled (null when there is at least one receipt) */
export function receiptUnavailableReason(reg: PublicRegistration): string | null {
  if ((reg.receipts ?? []).length > 0) return null;
  if (reg.registration_status === 'REJECTED') return 'La inscripción fue observada: no hay recibo.';
  if (reg.registration_status === 'PRE_REGISTERED') {
    return 'El recibo estará disponible cuando la comisión verifique la inscripción y confirme el pago.';
  }
  if (reg.payment_status === 'PAID' || reg.payment_status === 'PARTIAL') {
    return 'El pago fue confirmado, pero el recibo aún no fue emitido. Consulte con la comisión.';
  }
  return 'El pago aún no fue confirmado. El recibo se emite al confirmarse el pago.';
}
